/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SpecificCarrierPriorityShipmentsDTO {
  addressCity?: string;
  addressNeighborhood?: string;
  addressPostalCode?: string;
  addressState?: string;
  addressStreet?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  isShippingCompanyActive?: string;
  personCpf?: number;
  personEmail?: string;
  personId?: number;
  personName?: string;
  reason?: string;
  responsible?: string;
  shippingCompanyId?: number;
  shippingCompanyName?: string;
  specificCarrierPriorityShipmentsId?: number;
}
